export const FETCH_FORM_SCHEMA = 'FETCH_FORM_SCHEMA'
export const VALIDATE_VALUES = 'VALIDATE_VALUES'
export const BOOK = 'BOOK'
